<script lang="ts">
  import { afterNavigate } from '$app/navigation';
  import Alert from '$shared/atoms/Alert/Alert.svelte';
  import { AlertType } from '$shared/components';
  import '$shared/helpers/extensions';
  import globalAlertStore from '$shared/stores/globalAlertStore';
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();

  afterNavigate((navigation) => {
    dispatchEvent(new CustomEvent('service:route-change', { detail: navigation }));
  });

  const closeGlobalAlert = () => {
    globalAlertStore.setVersionUpdateAlert(false);
  };
</script>

<main>
  {#if $globalAlertStore.showVersionUpdateAlert}
    <div class="app-version-banner">
      <Alert options={{ type: AlertType.Warn }} closable={true} onclose={closeGlobalAlert}>
        <div class="content">
          <div class="title">
            A new update is ready. Automatic update failed. Please refresh the app shortly to get
            the latest version.
          </div>
        </div>
      </Alert>
    </div>
  {/if}
  {@render children?.()}
</main>

<style>
  .app-version-banner {
    position: fixed;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    z-index: 1000;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    color: #000;
  }
  .action {
    background: none;
    border: none;
    text-decoration: underline;
    padding: 0;
  }
</style>
